import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { numberWithCommas } from '@common/utils';

interface FirstOrderEnableTextProps {
  price: number;
}

export const FirstOrderEnableText: React.FC<React.PropsWithChildren<FirstOrderEnableTextProps>> = ({ price }) => {
  return (
    <Text>
      첫구매가는 ID당 최초 1개 상품에만 적용되며 해당 상품 포함 {numberWithCommas(price)}원 이상 주문 시 구매 가능
      (배송비 제외)
    </Text>
  );
};

const Text = styled.p`
  margin: 0 16px 8px 16px;
  padding: 14px 16px 12px 16px;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: ${vars.v3Color.gray600};
  background-color: ${vars.v3Color.gray50};
  border: 1px solid ${vars.v3Color.gray150};
  border-radius: 6px;
  word-break: keep-all;
`;
